export const FILTER_ALL = 'FILTER_ALL';
export const FILTER_USED = 'FILTER_USED';
export const FILTER_NOT_USED = 'FILTER_NOT_USED';
export const FILTER_MULTI_USED = 'FILTER_MULTI_USED';
